'use strict';

angular.module('mobile-apps').controller('DataImportSpreadsheetModalController', [
	'$scope',
	'ImportInfo',
	'MobileApps',
	'Utilities',
	'$modalInstance',
	function (
		$scope,
		ImportInfo,
		MobileApps,
		Utilities,
		$modalInstance
	) {

		$scope.spreadsheetData = {
			columnTypes: [],
			dataComplete: false,
			includeFirstRow: false
		};

		$scope.data = {
			fileContent: ImportInfo.fileContent,
			uploadInProgress: false,
			metadata: ImportInfo.mobileApp.metadata
		};

		if (ImportInfo.mobileApp.type === 'tm') {
			$scope.data.requiresKey = false;
		} else {
			$scope.data.requiresKey = true;
		}

		/**
		 * Close modal
		 */
		$scope.close = function() {
			$modalInstance.dismiss();
		};


		/**
		 * Start importing
		 */
		$scope.startImport = function () {
			var returnData = {};

			var sendData = {
				_id: ImportInfo.mobileApp._id,
				data: {
					spreadsheetOptions: {
						fileName: ImportInfo.file.fileName,
						fileNameOriginal: ImportInfo.file.fileNameOriginal,
						includeFirstRow: $scope.spreadsheetData.includeFirstRow,
						columnDescription: {},
						sheetName: $scope.spreadsheetData.sheetName
					},
					options: ImportInfo.options,
					entries: ImportInfo.entries,
					groupId: ImportInfo.groupId
				}
			};

			for (var i=0;i<$scope.spreadsheetData.columnTypes.length;i++) {
				var type = $scope.spreadsheetData.columnTypes[i];
				if (type) {
					sendData.data.spreadsheetOptions.columnDescription[type] = i;
				}
			}

			Utilities.loadingUiModal('open');

			MobileApps.importSpreadsheet(sendData).$promise.then(
			  function(data) {
				  Utilities.loadingUiModal('close');
				  $modalInstance.close(data);
			  }
			).catch(function(error) {
				Utilities.showMessage(
					'Error!',
					error.data.message,
					'error'
				);
				$modalInstance.close(returnData);
				Utilities.loadingUiModal('close');
			});
		};


	}
]);

